module.exports = __webpack_public_path__ + "static/media/communityMobile.11c996fd.png";